import HomeHeaderOther from "@/components/HomeHeader/indexOther";
import MyNavLink from "@/components/MyNavLink";
import UserLogShow from "@/components/UserLogShow";
import { LocalConfig } from "@/config";
import { PersistContext } from "@/data/PersistProvider";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { SendCMD } from "@/utils/HTTPRequest";
import { ChannelRemind } from "@/utils/UrlHelper";
import { useContext, useEffect, useState } from "react";
import { DropdownMenu, List, Pagination } from "react-vant";
import style from "./style.less";

const DepositLog = () => {
  const { getPersist } = useContext(PersistContext);
  const history = useEnhancedHistory();

  const [list, setList] = useState(1);

  //设置是否已加载完成
  const [finished, setFinished] = useState(false);

  //设置页码数
  const [pageCount, setPageCount] = useState(false);
  const [page, setPage] = useState(1);

  //设置选择条件
  const [rangeType, setRangeType] = useState(false);

  //返回数据
  const [dataLog, setDataLog] = useState([]);
  const [dataLogLength, setDataLogLength] = useState(0);

  console.log(getPersist("user_info"));
  useEffect(() => {
    if (!getPersist("dataLoaded")) {
      return;
    }
    if (!getPersist("user_info")) {
      history.push(ChannelRemind("/login"));
      return;
    }
    getPayOrders(page);
  }, [getPersist("user_info")]);

  const [logSearchBg, setLogSearchBg] = useState("#10473f");
  const setParentBackground = (type) => {
    if (type === "open") {
      setLogSearchBg("#2B685F");
    } else if (type === "close") {
      setLogSearchBg("#10473f");
    }
  };

  //获取记录
  const getPayOrders = (page) => {
    SendCMD("payOrders", {
      token: getPersist("user_info").token,
      order_type: "deposit",
      range_type: rangeType.selectValue,
      page: page,
    }).then((res) => {
      if (res.rows.length > 0) {
        setPageCount(res.total_page);
        let option = [];
        res.rows.map((value, index) => {
          let statusText = value.status;
          if (value.status === "FAILD") {
            statusText = "FAILED";
          }
          if (value.status === "INIT") {
            statusText = "ONGOING";
          }
          if (value.status === "MANUAL") {
            statusText = "SUCCESS";
          }
          option.push({
            time: value.create_time,
            amount: value.price / 100,
            status: statusText,
          });
        });
        setDataLog(option);
        setDataLogLength(option.length);
      }
    });
  };

  //加载
  const onLoad = async () => {
    setList((v) => [...v, ...dataLog]);
    if (list.length >= 30) {
      setFinished(true);
    }
  };

  const optionRangeType = [
    {
      value: "today",
      text: "Today",
    },
    {
      value: "3days",
      text: "Three Days",
    },
    {
      value: "7days",
      text: "Seven Days",
    },
    {
      value: "30days",
      text: "Thirty Days",
    },
  ];

  const onDropdownMenuChange = (value) => {
    setRangeType(value);
    setPage(1);
  };

  const onPaginationChange = (value) => {
    setPage(value);
    getPayOrders(value);
  };

  return (
    <>
      <div class={style.page_container}>
        <HomeHeaderOther title="Deposit Records" backToUrl={-1} />
        <div class={style.help_content_log}>
          <div class={style.log}>
            <div class={style.log_search} style={{ backgroundColor: logSearchBg }}>
              <DropdownMenu
                activeColor=""
                value={rangeType}
                onChange={onDropdownMenuChange}
                onClosed={getPayOrders}
                onOpen={() => setParentBackground("open")}
                onClose={() => setParentBackground("close")}
                style={{
                  "--rv-dropdown-menu-title-text-color": "#055d27",
                  "--rv-button-primary-border-color": "#055d27",
                  "--rv-tab-active-text-color": "#ffffff",
                  "--rv-dropdown-menu-background-color": "#A7D54E",
                  "--rv-cell-background-color": "#2B685F",
                  "--rv-cell-text-color": "#ffffff",
                  "--rv-cell-border-color": "#44857B",
                  "--rv-dropdown-menu-title-font-size": "1.5rem",
                  "--rv-dropdown-menu-title-line-height": "1.8rem",
                  "--rv-cell-line-height": "1.53rem",
                  width: "100%",
                  fontWeight: "bold",
                }}
              >
                <DropdownMenu.Item placeholder="Today" name="selectValue" options={optionRangeType} />
              </DropdownMenu>
            </div>
            <div class={style.log_intro}>
              Your deposit might take at most 24 hours to be credited. If your deposit does not processed after 24
              hours, please{" "}
              <MyNavLink to="/contact">
                <span>contact us!</span>
              </MyNavLink>{" "}
              Your ID is: {getPersist("user_info") ? getPersist("user_info").rid : null}
            </div>
            <div class={style.log_list}>
              <div class={style.info}>
                <div class={style.info_time}>Time</div>
                <div class={style.info_amount}>Amount({LocalConfig.currencyCode})</div>
                <div class={style.info_status}>Order Status</div>
              </div>
              <List finished={finished} onLoad={onLoad}>
                {dataLog && dataLog.length ? (
                  dataLog.map((v, i) => {
                    return <UserLogShow k={i} info={v} length={dataLogLength} />;
                  })
                ) : (
                  <div class={style.log_list_no}>No Data</div>
                )}
              </List>
              <div class={style.log_page}>
                <Pagination
                  prevText="Prev"
                  nextText="Next"
                  value={page}
                  mode="simple"
                  onChange={onPaginationChange}
                  pageCount={pageCount}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DepositLog;
